import React from "react";
export default function Privacy(_ref) {
  var pageName = _ref.pageName,
    pageTitle = _ref.pageTitle,
    privacyPolicy = _ref.privacyPolicy;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: pageName
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-title"
  }, /*#__PURE__*/React.createElement("h3", null, pageTitle)), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, privacyPolicy ? /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: privacyPolicy
    },
    className: "text editor"
  }) : /*#__PURE__*/React.createElement("div", {
    className: "text editor"
  }, " - "))));
}